import type { IconName } from '@customerio/pluma-icons';

export type ChannelOption = {
  value: string;
  label: string;
  icon: IconName;
};

/** The message channels offered on the channels step, in display order. */
export const CHANNEL_OPTIONS: ChannelOption[] = [
  { value: 'email', label: 'Email', icon: 'email' },
  { value: 'sms', label: 'SMS', icon: 'sms' },
  { value: 'push', label: 'Push', icon: 'mobile' },
  { value: 'in_app', label: 'In-App', icon: 'in-app' },
  { value: 'whatsapp', label: 'WhatsApp', icon: 'brand/whatsapp' },
  { value: 'slack', label: 'Slack', icon: 'brand/slack' },
];
